interface CardSectionProps {
  title: string;
  description: string;
  emoji: string;
  listItems: string[];
  buttonText: string;
  onClick: () => void;
}

const CardSection: React.FC<CardSectionProps> = ({
  title,
  description,
  emoji,
  listItems,
  buttonText,
  onClick,
}) => {
  return (
    <div className="flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border border-gray-100 rounded-lg shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
      <h3 className="mb-4 text-2xl font-semibold">{title}</h3>
      <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">
        {description}
      </p>
      <div className="flex items-baseline justify-center my-8">
        <span className="mr-2 text-8xl font-extrabold">{emoji}</span>
      </div>

      <ul role="list" className="mb-8 space-y-4 text-left">
        {listItems.map((item, index) => (
          <li key={index} className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              ></path>
            </svg>
            <span>{item}</span>
          </li>
        ))}
      </ul>
      <button
        onClick={onClick}
        className="text-white bg-teal-600 hover:bg-teal-700 focus:ring-4 focus:ring-teal-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-white dark:focus:ring-teal-900"
      >
        {buttonText}
      </button>
    </div>
  );
};

export default CardSection;
